import React, { useState, useEffect } from "react";
import * as account from "../../api/account/index";
import * as StyledGlobalCSS from "../../constants/common/StyledGlobalConstants";
import { connect } from "react-redux";
import "../../App.css";
import InvoiceAddContact from "./InvoiceAddContact";
import DiscardModal from "../myContract/DiscardModal";
import { useTranslation } from "react-i18next";
import { useCountryListContext } from "../../contexts/CountryListContext";
import PropTypes from "prop-types";
function AddContact(props) {
  const [showContactModal, setShowContactModal] = useState(false);
  const [showUnsavedModal, setShowUnsavedModal] = useState(false);
  const [contactFirstName, setContactFirstName] = useState("");
  const [contactLastName, setContactLastName] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [load, setLoad] = useState(false);
  const [notification, setNotification] = useState({
    show: false,
    type: "",
    title: "",
  });
  const [t] = useTranslation("manageInvoiceTranslation");
  const validFinancialStatuses = ["Active", "Reactivated"];
  const { fetchCountryList, loading } = useCountryListContext();
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setShowContactModal(false);
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);

  const postAddContact = () => {
    let contractId = props.contractAccountCallResponse?.getContractAccountCallResponse
      .filter((record) => record.uuid === props.contractAccountCallResponse.uuid && validFinancialStatuses.includes(record.financialStatus))
      .map((item) => item.contractAccountId);
    let postData = {
      firstName: contactFirstName,
      lastName: contactLastName,
      accountId: props.accountId,
      email: contactEmail,
      contractId: contractId?.length === 1 ? contractId[0] : contractId?.join(";"),
      phone: contactPhone,
    };
    setLoad(true);
    account
      .createNewContact(postData)
      .then((response) => {
        if (response.data.statusCode === "200") {
          setLoad(false);
          props.addContactNotification();
          props.setTableData([
            {
              emailId: postData.email,
              receiveInvoices: true,
              status: "Add recipient pending",
              contactId: postData.contractId,
              contactFirstName: postData.firstName,
              contactLastName: postData.lastName,
              contactStatus: "Active",
            },
            ...props.tableData,
          ]);
          cancelAddContact();
        } else {
          setLoad(false);
          setNotification({
            show: true,
            type: "error",
            title: t("There was a problem submitting your information. Please try again."),
          });
        }
      })
      .catch((requestError) => {
        setLoad(false);
        setNotification({
          show: true,
          type: "error",
          title:
            requestError.response.status === 409
              ? t("The recipient you are trying to add is already in the recipient list.")
              : t("There was a problem submitting your information. Please try again."),
        });
      });
  };

  const cancelAddContact = () => {
    setShowContactModal(false);
  };

  const openAddContact = () => {
    setShowContactModal(true);
    setContactFirstName("");
    setContactLastName("");
    setContactEmail("");
    setContactPhone("");
    fetchCountryList();
  };

  const closeUnsavedAndContactModal = () => {
    setNotification({ show: false, type: "", title: "" });
    setShowUnsavedModal(false);
    setShowContactModal(!showContactModal);
  };

  const closeUnsavedModal = () => {
    setShowUnsavedModal(false);
  };

  return (
    <>
      <StyledGlobalCSS.CPButton
        id="add-contact"
        size="large"
        fontSize="14px"
        fontPaddingLeft="1rem"
        fontPaddingRight="1rem"
        boxButton={true}
        buttonWidth={"100% !important"}
        style={{
          height: "2.5rem",
          marginTop: "0rem",
        }}
        onClick={openAddContact}
        ariaLabel="Add Contact"
        disabled={props.isAnyContactPending}
      >
        {t("ADD RECIPIENT")}
      </StyledGlobalCSS.CPButton>

      {showUnsavedModal && (
        <DiscardModal
          open={showUnsavedModal}
          onClose={() => closeUnsavedModal()}
          yesButtonId="add-invoice-contact-lose-change-yes-button"
          noButtonId="add-invoice-contact-lose-change-no-button"
          onYesButtonClick={() => closeUnsavedAndContactModal()}
          windowSize={props.windowSize}
        />
      )}

      <div style={{ overflowX: "hidden" }}>
        <InvoiceAddContact
          windowSize={props.windowSize.width}
          backToBillingScreen={(passingVal) => setShowContactModal(passingVal)}
          unSavedModal={(passingVal) => setShowUnsavedModal(passingVal)}
          firstNameRes={(res) => setContactFirstName(res)}
          lastNameRes={(res) => setContactLastName(res)}
          emailRes={(res) => setContactEmail(res)}
          phoneRes={(res) => setContactPhone(res)}
          onSaveButtonClicked={() => postAddContact()}
          errorNotification={notification}
          onErrorNotificationClose={() => setNotification({ show: false, type: "", title: "" })}
          showContactModal={showContactModal}
          regionId={props.regionId}
          load={load}
          isCountryListLoading={loading}
        />
      </div>
    </>
  );
}

AddContact.propTypes = {
  contractAccountCallResponse: PropTypes.shape({
    uuid: PropTypes.string,
    getContractAccountCallResponse: PropTypes.arrayOf(
      PropTypes.shape({
        uuid: PropTypes.string,
        financialStatus: PropTypes.string,
        contractAccountId: PropTypes.string,
      })
    ),
  }),
  accountId: PropTypes.string.isRequired,
  addContactNotification: PropTypes.func.isRequired,
  setTableData: PropTypes.func.isRequired,
  tableData: PropTypes.array.isRequired,
  isAnyContactPending: PropTypes.bool.isRequired,
  windowSize: PropTypes.shape({
    width: PropTypes.number.isRequired,
  }).isRequired,
  regionId: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  return {
    accountId: state.ACCOUNT.account_id,
    contractId: state.BILLING.contractId,
    windowSize: state.ACCOUNT.windowSize,
    regionId: state.ACCOUNT.regionId,
    contractAccountCallResponse: state.BILLING.contractAccountCallResponse,
  };
};

export default connect(mapStateToProps, null)(AddContact);
